const BlogObj = [
    {
        img: './images/Godzila.jpg',
        title: 'Godzilla Minus One',
        description: 'Godzilla Minus One manages an impressive box office haul one year after its initial release. The Toho-produced kaiju movie tells the story of postwar Japan riddled with a new crisis when a giant reptilian monster takes over their major cities. Godzilla Minus One was met with positive reviews upon its release on December 1, 2023...',
        link: 'https://screenrant.com/godzilla-minus-one-box-office-update-rerelease/'

    },
    {
        img: './images/Pirates.jpg',
        title: 'Pirates of the Caribbean',
        description: 'Johnny Depp returning for Pirates of the Caribbean 6 wouldnt be a solve- all—the Disney franchises box-office trends prove that it must return to the basics. Another Pirates of the Caribbean sequel has been confirmed, but just about everything is still in the air with this project... ',
        link: 'https://screenrant.com/pirates-of-the-caribbean-budget-trend-go-back-nostalgia/'

    },
    {
        img: './images/Suits.jpg',
        title: 'Suits',
        description: 'Suits creator Aaron Korsh talks about one change Suits LA has to make due to the networks policies. Suits aired on the USA Network from 2011 to 2019, which is a basic cable television channel owned by NBCUniversal Media Group. The upcoming spinoff series follows prosecutor-turned-entertainment lawyer...',
        link: 'https://screenrant.com/suits-la-show-changes-network-tv-original-series/'

    },

    {
        img: './images/kill.jpg',
        title: 'Kill',
        description: 'Purely as an action thriller, Nikhil Nagesh Bhat’s Kill is slick, savage and supremely satisfying to watch. It ticks all the boxes: Creative choreography, relentless rhythm, unforgiving gore, the tactful use of space, the raw physicality of the performers, a real-world rage.Its bloodlust isn’t for the faint-hearted, but the violence doubles up as a cautionary tale...',
        link: 'https://www.filmcompanion.in/reviews/bollywood-review/kill-review-ddlj-but-make-it-gory-gruesome-and-awesome'
    },
    {
        img: './images/JohnWick.jpg',
        title: 'John - Wick',
        description: 'The John Wick franchises surprising accuracy to the mafia explains why Keanu Reeves titular character has appeared in four highly successful movies.John Wick has become a massive name in the action movie genre in the last decade as Keanu Reevess character has become a fan-favorite all over the world...',
        link: 'https://screenrant.com/john-wick-mafia-accurate-franchise-streak-op-ed/'
    },
    {
        img: './images/dange.jpg',
        title: 'Dange',
        description: 'Dange is set in and around a volatile college called St. Martin’s in Goa. Dudes live in shacks, do drugs, pick fights and roll into campus on beach buggies. Dudettes blow marijuana smoke into each other’s mouths. There are all of four recurring faculty members, who spend their scenes listening to protesting students...',
        link: 'https://www.filmcompanion.in/reviews/bollywood-review/dange-review-alls-fair-in-testosterone-and-war-bejoy-nambiar'
    },
    {
        img: './images/BeetlejuiceBeetlejuice.jpg',
        title: 'Beetlejuice - Beetlejuice',
        description: 'Even after nine weekends, Beetlejuice Beetlejuice has conjured even more box office success through new records. The Tim Burton-directed sequel follows up on the story first established by the cult classic 80s movie.This time, it tells the story of Lydias daughter Astrid, who accidentally opens the portal to the Afterlife once again...',
        link: 'https://screenrant.com/beetlejuice-beetlejuice-box-office-record-top-75-pg-13/'
    },

    {
        img: './images/Terminator.jpg',
        title: 'Terminator',
        description: 'Aliens and The Terminator actor Michael Biehn is set to star in his first major studio movie in decades.Biehn famously played Corporal Dwayne Hicks in Aliens and Kyle Reese, the father of John Connor, in The Terminator.In more recent years, he had a memorable guest appearance in one of the best The Mandalorian episodes...',
        link: 'https://screenrant.com/onslaught-a24-movie-michael-biehn-cast/'
    },

    {
        img: './images/Infiltratore.jpg',
        title: 'Infiltratore',
        description: 'The Infiltrator, directed by Brad Furman, chronicles the efforts of a U.S. Customs official who goes undercover to expose a complex money laundering operation tied to the infamous drug lord Pablo Escobar. Set in the 1980s, the film delves into the intricate world of crime and corruption...',
        link: 'https://screenrant.com/db/movie/the-infiltrator/'
    },

    {
        img: './images/chandu.jpg',
        title: 'Chandu Champion',
        description: 'If you review Hindi films every week, chances are that the “biographical drama” strikes fear in your heart. There is no escape (or escapism). Most biopics are great stories looking for an excuse – rather than a medium – to be told. All that matters is the significance of the life in question...',
        link: 'https://www.filmcompanion.in/reviews/bollywood-review/chandu-champion-review-kabir-khan-and-kartik-aaryan-win-against-all-odds'
    },

    {
        img: './images/Crew.jpg',
        title: 'Crew',
        description: 'Crew revolves around the get-rich-quick adventures of three flight attendants – newbie Divya Rana (Kriti Sanon), mid-career Jasmine Kohli (Kareena Kapoor Khan) and veteran Geeta Sethi (Tabu) – who work for a commercial carrier named Kohinoor. Broke and sick of being middle-class...',
        link: 'https://www.filmcompanion.in/reviews/bollywood-review/crew-review-tabu-kareena-kriti-take-you-on-a-bumpy-flight'
    },

    {
        img: './images/padmaavat.jpg',
        title: 'Padmaavat',
        description: 'Like his villain Alauddin Khilji, Sanjay Leela Bhansali is a director with a ravenous appetite. He has an insatiable hunger for drama, romance and above all, beauty. Early in Padmaavat, Khilji declares – har nayab cheez par Allauddin ka haq hai. It could have been Sanjay speaking...',
        link: 'https://www.filmcompanion.in/reviews/padmaavat-movie-review-anupama-chopra'
    },

    {
        img: './images/DeadpoolWolverine.jpg',
        title: 'Deadpool & Wolverine',
        description: 'Though the prospect of Deadpool coming back for a third film would have been enough to draw audiences in, Deadpool & Wolverine upped the movies box office appeal by bringing back Hugh Jackman to star alongside Ryan Reynolds.Jackman had previously played Wolverine for 17 years before retiring from the role...',
        link: 'https://screenrant.com/ryan-reynolds-deadpool-wolverine-scene-most-terrifying-to-write/'
    },

    {
        img: './images/kalki.jpg',
        title: 'Kalki 2898 AD',
        description: 'The arrival of an expensive big-screen epic only elicits extreme reactions. Given the scale and hype, the film is allowed to be either a masterpiece or a disaster. From the viewers’ point of view, it cannot be anything else; the stakes are too high. It’s almost as if the size of such movies demands nothing less than passionate love or passionate criticism...',
        link: 'https://www.filmcompanion.in/reviews/kalki-2898-ad-review-a-brave-new-world-of-myth-science-fiction-and-middling-performances'
    },
    {
        img: './images/Oppenheimer.jpg',
        title: 'Oppenheimer',
        description: 'Oppenheimer is a film by Christopher Nolan, which follows the theoretical physicist J. Robert Oppenheimer, the man behind the atomic bomb. Cillian Murphy will play the titular role, with the story based on the book American Prometheus: The Triumph and Tragedy of J. Robert Oppenheimer by Kai Bird and Martin J. Sherwin...',
        link: 'https://screenrant.com/oppenheimer-cillian-murphy-oscar-win-reflection/'
    },

    {
        img: './images/Blade.jpg',
        title: 'Blade',
        description: ' The Marvel Cinematic Universe initiated its Blade movie way back in 2021, yet the movie doesn’t seem any closer to release. Three years ago, the Marvel Cinematic Universe officially introduced Blade, hinting at the long-awaited revival of the iconic vampire hunter.Played by Mahershala Ali, Blade was positioned to bring a darker, supernatural element to the MCU, generating enormous excitement...',
        link: 'https://screenrant.com/marvel-blade-eternals-setup-not-happened-yet/'
    },

    {
        img: './images/StarWars.jpg',
        title: 'Star Wars',
        description: 'Three years before Anakin Skywalker fell to the dark side and became Darth Vader in Star Wars, he warned Padmé about one of his gravest shortcomings—yet she, and the Jedi, didnt understand these signs in time. Anakin Skywalkers Star Wars timeline is one of the most devastating aspects of Star Wars movies and TV shows...',
        link: 'https://screenrant.com/anakin-skywalker-padme-dark-side-fall-prediction-factoid/'
    },

    {
        img: './images/Bastar.jpg',
        title: 'Bastar',
        description: 'In the interviews given ahead of the release of Bastar: The Naxal Story (2024), creative director, writer and producer Vipul Amrutlal Shah rubbished the idea that his film may be made with the intention of promoting a political point of view. “Today, the way BJP is poised in this election, do they really need our film to win the election? That’s the most stupid and bizarre thing that I have heard,” Shah told India Today...',
        link: 'https://www.filmcompanion.in/reviews/bollywood-review/bastar-the-naxal-story-review-a-simplistic-take-on-a-complicated-history'
    },
]

export default BlogObj
